<template>
  <div class="record" :class="{ inApp: $root.$data.isApp || $root.miniprogram }">
    <common-title titleName="活动记录" :bcColor="'#F7F8FC'" :zIndex="1000"></common-title>
    <div class="record-content">
      <div class="sub-nav-fixed" :class="{ subFixed:$root.$data.isApp || $root.miniprogram }">
        <dl>
          <dd
            v-for="(item, index) in subNavList"
            :key="index"
            :class="{ chooseActive: selected === index }"
            @click="chooseInfo(index)"
          >
            {{ item.name }}
          </dd>
        </dl>
      </div>
      <div class="record-content-wrap" :class="{ recordwrap: $root.$data.isApp || $root.miniprogram }">
        <recordCard :cardActiveId="cardActiveId" v-if="selected === 0" />
      <recordSelect :cardActiveId="cardActiveId" v-if="selected === 1" />
      <recordPrize :cardActiveId="cardActiveId" v-if="selected === 2" /> 
      </div>

      
    </div>
  </div>
</template>

<script>
import recordCard from './component/recordCard.vue';
import recordSelect from './component/recordSelect.vue';
import recordPrize from './component/recordPrize.vue';

export default {
  components: {
    recordCard,
    recordSelect,
    recordPrize,
  },
  data() {
    return {
      selected: 0,
      cardActiveId: this.$route.query.cardActiveId || 1,
      subNavList: [
        {
          name: '卡片记录',
        },
        {
          name: '抽卡次数',
        },
        {
          name: '奖品记录',
        },
      ],
    };
  },

  computed: {},
  created() {},

  mounted() {
    document.title = '活动记录';
   
  },

  methods: {
    chooseInfo(index) {
      this.selected = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.record-content {
  padding-top: 100px;
  background-color: #f7f8fc;
  &.inApp {
  padding-top: 0px;
}
.record-content-wrap{
  margin-top:100px;
  &.recordwrap{
    margin-top:40px;
  }
}
  
  .sub-nav-fixed {
    position: fixed;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 70px;
    background-color: #f7f8fc;
    z-index: 9;
    &.subFixed{
      top:0;
    }
  }
  dl {
    display: flex;
    justify-content: center;
    align-content: center;
    width: 565px;
    background: #f1f1f1;
    border-radius: 14px;
    margin: 0 auto;
    padding: 6px;
    dd {
      width: 181px;
      height: 58px;
      line-height: 58px;
      border-radius: 13px;
      font-weight: 400;
      font-size: 29px;
      color: #333333;
      text-align: center;
    }
    .chooseActive {
      background: #ffffff;
      color: #ff7f41;
    }
  }
}
</style>
